export default function validateTags(input, excludedTags, key, index) {
  const validLanguages = [
    'c',
    'c_sharp',
    'cpp',
    'go',
    'java',
    'javascript',
    'kotlin',
    'php',
    'python',
    'ruby',
    'rust',
    'scala',
    'typescript',
  ];

  const validTags = [
    'default',
    'translate',
    'from',
    'quiz',
    'question',
    'option',
    'option-correct',
    'feedback-correct',
    'feedback-incorrect',
    'explanation',
    'hint',
    'continue',
    'coding',
    'swedish',
    'english',
    'switch',
  ].concat(validLanguages);

  const languagePattern = validLanguages.join('|');
  const validTagPattern = new RegExp(
    `^(${validTags.join('|')}|level\\d+|interact-\\d+|(${languagePattern})(\\|(${languagePattern}))*$)`
  );

  const combinedTagPattern = /\[\/?([a-zA-Z0-9_]+(?:\|[a-zA-Z0-9_]+)*)\]/g;

  let stack = [];
  let mismatchedTags = [];
  let invalidTags = [];
  let nestedTags = [];

  let match;
  while ((match = combinedTagPattern.exec(input)) !== null) {
    let tag = match[1];

    // Exclude below tags as they are part of the flow but not part of the tag pattern
    if (excludedTags?.length && excludedTags?.includes(tag)) continue;

    if (!validTagPattern.test(tag)) {
      invalidTags.push(tag);
      continue;
    }

    if (match[0][1] !== '/') {
      // Opening tag
      if (stack.includes(tag)) {
        nestedTags.push(tag);
      }
      stack.push(tag);
    } else {
      // Closing tag
      if (stack.length === 0 || stack[stack.length - 1] !== tag) {
        mismatchedTags.push(tag);
      } else {
        stack.pop();
      }
    }
  }

  // Any remaining tags in the stack are unmatched opening tags
  mismatchedTags = mismatchedTags.concat(stack);

  return {
    isValid: mismatchedTags.length === 0 && invalidTags.length === 0 && nestedTags.length === 0,
    mismatchedTags: [...new Set(mismatchedTags)],
    invalidTags: [...new Set(invalidTags)],
    nestedTags: [...new Set(nestedTags)],
  };
}
